import * as React from 'react';
import PropTypes from 'prop-types';
import TreeView from '@mui/lab/TreeView';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import { CustomAddTreeItem } from './CustomAddTreeItem';
import { StyledTreeItem } from './CustomTreeItem';

export const OrgTree = ({ branches }) => {
  return (
    <TreeView
      aria-label="gmail"
      defaultExpanded={['3']}
      defaultCollapseIcon={<ExpandMoreIcon />}
      defaultExpandIcon={<ChevronRightIcon />}
      defaultEndIcon={<div style={{ width: 24 }} />}
      sx={{ flexGrow: 1, overflowY: 'auto' }}
      data-testid="TreeView"
    >
      {branches.map((branch, index, array) => {if (array.findIndex(item => branch.id === item.id) === index) return branch})
        .filter(branch => branch)
        ?.map((branch, index) => {
        return (
          <StyledTreeItem
            key={`branch${branch.id}`}
            nodeId={index.toString()}
            type="branch"
            branchId={branch.id}
            label={branch.label}>
            {branch.departments?.map((department, i) => {
              return (
                <StyledTreeItem
                  key={department.id}
                  branchId={branch.id}
                  departmentId={department.id}
                  nodeId={`${index}.${i + 1}`}
                  label={department.label}
                  type="department"
                />
              );
            })}
            <CustomAddTreeItem nodeId={`${index}.${0}`} branchId={branch.id} type="department" label={''}/>
          </StyledTreeItem>
        );
      })}
      <CustomAddTreeItem nodeId={(branches?.length + 2).toString()} type="branch" label={''}/>
    </TreeView>
  );
};

OrgTree.propTypes = {
  branches: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      id: PropTypes.string,
      departments: PropTypes.array
    })
  )
};
